

import IsiOrtuForum from "./src/IsiOrtuForum";

export default IsiOrtuForum